/* eslint-disable @next/next/no-img-element */
"use client";

export default function Img({
  imgScale = 1,
  avgLineHeight = 1,
  fragment: { id, alt = "image", width, height, src, inline }
}) {
  return (
    <img
      key={Date.now()}
      id={id}
      alt={alt}
      src={src}
      width={width}
      height={height}
      onLoad={event => {
        const img = event?.target ?? event;
        const imgParent = img.parentNode;
        const closestParagraph = imgParent.closest("p");
        const currentFontSize = Number(
          getComputedStyle(closestParagraph).lineHeight.slice(0, -2)
        );
        const scaledLineHeight = avgLineHeight * imgScale;
        const scalingFactor = currentFontSize / scaledLineHeight;
        const adjustedWidth = (width ?? img.naturalWidth) * scalingFactor; //* 1.1;

        if (inline) {
          const adjustedHeight =
            ((height ?? img.naturalHeight) * scalingFactor) / 1.1;

          img.style.height = `${adjustedHeight}px`;
        } else {
          img.style.width = `${adjustedWidth}px`;
        }
      }}
      style={
        inline
          ? { width: "auto" }
          : {
              maxWidth: "90%",
              margin: "auto",
              height: "auto",
              display: "block"
            }
      }
    />
  );
}
